import React from 'react';

/**
 * Apple-style toggle switch — 44pt tap target, smooth knob slide.
 * Replaces ad-hoc toggles repeated across NotificationSettings, PromptSettings, etc.
 */
const Toggle = ({ checked, onChange, disabled = false, ariaLabel }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => !disabled && onChange(!checked)}
    className={`relative inline-flex items-center min-w-[51px] h-[31px] rounded-full transition-colors duration-200 flex-shrink-0 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed ${
      checked ? 'bg-blue-500' : 'bg-gray-600'
    }`}
  >
    <span
      className={`inline-block w-[27px] h-[27px] rounded-full bg-white shadow-sm transform transition-transform duration-200 ${
        checked ? 'translate-x-[22px]' : 'translate-x-[2px]'
      }`}
    />
  </button>
);

export default Toggle;
